import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';
import {TITLE_APPEND} from '@/Constants';
import {UtilsService} from '@/services/utils.service';

interface MapData { name: string; thumb: string; full: string; }
interface Adventure { subtitle: string; title: string; coverThumb: string; description: string; maps: MapData[]; }

@Component({
  selector: 'app-gallery-books',
  templateUrl: './gallery-books.component.html',
  styleUrls: ['./_gallery-books.component.scss']
})
export class GalleryBooksComponent implements OnInit, OnDestroy {
  // private subs: Subscription[] = [];
  currentRotation = 0;
  selectedMap: MapData | null = null;
  unlockedAdventures: boolean[] = [false, false, false, false, false, false];
  showAmazonCTA = true;

  adventures: Adventure[] = [
    { subtitle: 'Frosthold',
      title: 'A Merry Fucking Christmas',
      coverThumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Mask_1.png',
      description: 'Un\'indagine tra le nevi perenni. In un\'atmosfera carica di tensione e freddo pungente, dovrete scoprire cosa si cela dietro una festività che ha preso una piega decisamente oscura e violenta.', maps: [
      {name: 'Villaggio di Frosthold', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Frosthold_Villaggio2.min.jpg', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Frosthold_Villaggio2.jpg'},
      {name: 'Museo di Babbo Natale', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Frosthold_Museo.min.jpg', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Frosthold_Museo.jpg'},
      {name: 'Laboratorio di Babbo Natale - Piano terra',
        thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Frosthold_LaboratorioTerra3.min.jpg',
        full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Frosthold_LaboratorioTerra3.jpg'},
      {name: 'Laboratorio di Babbo Natale - Primo piano',
        thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Frosthold_LaboratorioPrimo3.min.png',
        full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Frosthold_LaboratorioPrimo3.png'},
    ]},
    { subtitle: 'Kaleidos',
      title: 'Carnival Festival',
      coverThumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Mask_2.png',
      description: 'Tra maschere vibranti e vicoli in festa, il carnevale di Kaleidos nasconde insidie dietro ogni sorriso dipinto. Un\'avventura urbana dove l\'apparenza inganna e il confine tra spettacolo e pericolo è sottile come un filo di seta.', maps: [
      {name: 'Villaggio di Kaleidos', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Kaleidos4.min.jpg', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Kaleidos4.jpg'},
      {name: 'Cattedrale di Kaleidos', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Kaleidos_Cathedral5.min.png', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Kaleidos_Cathedral5.png'},
    ]},
    { subtitle: 'Eggs Town',
      title: 'Easter Gems',
      coverThumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Mask_3.png',
      description: 'Un\'esplorazione che si spinge nel cuore pulsante della terra, tra cavità dimenticate e tesori cristallizzati. In un viaggio verso l\'ignoto, dovrete districarvi tra le antiche tradizioni della cittadina e i segreti sepolti nelle profondità, dove le gemme attendono di essere ritrovate.', maps: [
      {name: 'Eggs Town', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/EggsTown4.min.jpg', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/EggsTown3.jpg'},
      {name: 'Casa di Eggs Town', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/EggsTown_House2.min.jpg', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/EggsTown_House2.jpg'},
        {name: 'Miniera', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/EggsTown_Miniera7.min.png', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/EggsTown_Miniera7.png'},
    ]},
    { subtitle: 'Islas',
      title: 'Pirate Blood',
      coverThumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Mask_4.png',
      description: 'Sulle rotte battute dai predoni del mare, Isla Magna attende chi ha il coraggio di sfidare la sorte. Un viaggio tra rotte piratesche, codici d\'onore brutali e il richiamo di un\'eredità scritta nel sangue.', maps: [
      {name: 'Nave dei pirati', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Islas_NavePirata2.min.jpg', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Islas_NavePirata2.jpg'},
      {name: 'Spiaggia', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Islas_Spiaggia.min.jpg', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Islas_Spiaggia.jpg'},
    ]},
    { subtitle: 'Piramide di Thutmose III',
      title: 'Immortal Treasures',
      coverThumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Mask_5.png',
      description: 'Nelle profondità delle sabbie desertiche, la tomba di un antico faraone riemerge dal passato. Esplorate corridoi dimenticati e superate trappole millenarie per svelare i tesori immortali custoditi dal tempo e dalla magia.', maps: [
      {name: 'Stanza della piramide', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Thutmose_Piramide_Stanza1.min.png', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Thutmose_Piramide_Stanza1.png'},
      {name: 'Stanza grande della piramide', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Thutmose_Piramide_Stanza2.min.png', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Thutmose_Piramide_Stanza2.png'},
      {name: 'Cripta della piramide', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Thutmose_Piramide2.min.png', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Thutmose_Piramide2.png'},
    ]},
    { subtitle: 'Bosco dei Sospiri',
      title: 'Black Sand',
      coverThumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/Mask_6.png',
      description: 'Un viaggio ai confini della realtà, dove la sabbia nera segna il passo di un\'esperienza che mette alla prova la tenuta mentale dei viaggiatori. Un\'avventura introspettiva e spettrale, dove ogni scelta ha un peso sulla vostra lucidità.', maps: [
      {name: 'Black Sand - Stanza della piramide', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/BlackSand_Piramide.min.png', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/BlackSand_Piramide.png'},
        {name: 'Black Sand - Nave fantasma', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/BlackSand_Nave.min.jpg', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/BlackSand_Nave.jpg'},
      {name: 'Black Sand - Bosco dei sospiri', thumb: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/BlackSand_Bosco5.min.jpg', full: 'https://tools.sandbay.it/public/dnd/oneshots/maps/thumbs/BlackSand_Bosco5.jpg'},
    ]},
  ];

  constructor(private _router: Router,
              private _title: Title,
              private _meta: Meta,
              private route: ActivatedRoute,
              private _utilsService: UtilsService) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      // Se il parametro 'ref' è uguale a 'in' o 'internal', nascondiamo il tasto
      this.showAmazonCTA = !(params.ref === 'in' || params.ref === 'internal');
    });
    this._title.setTitle(`Il Grimorio dei Mondi ${TITLE_APPEND}`);
    this._meta.updateTag({name: 'description', content: 'Sei orizzonti. Sei destini. Un unico viaggio oltre l\'immaginazione.'});
    this._meta.updateTag({property: 'og:title', content: `Il Grimorio dei Mondi ${TITLE_APPEND}`});
    this._meta.updateTag({property: 'og:description', content: 'Sei orizzonti. Sei destini. Un unico viaggio oltre l\'immaginazione.'});
    this._meta.updateTag({property: 'og:image', content: 'https://tools.sandbay.it/public/books/images/IlGrimorioDeiMondi.jpg'});
    this._meta.updateTag({property: 'og:url', content: `https://www.sandbay.it/gallery-books/grimorio/`});
    this._utilsService.createLinkForCanonicalURL(`https://www.sandbay.it/gallery-books/grimorio/`);
  }

  openLightbox(map: MapData) {
    this.currentRotation = 0; // Reset della rotazione all'apertura
    this.selectedMap = map;
  }

  closeLightbox() {
    this.selectedMap = null;
    this.currentRotation = 0;
  }

  rotateImage(event: Event) {
    event.stopPropagation(); // Evita che il click chiuda il lightbox
    this.currentRotation += 90;
  }

  downloadImage(event: Event) {
    event.stopPropagation();
    if (!this.selectedMap) { return; }

    const imageUrl = this.selectedMap.full;
    const fileName = ('grimorio-' + this.selectedMap.name) || 'mappa-grimorio';

    fetch(imageUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName.toLocaleLowerCase().replace(/\s+/g, '-') + '.jpg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(err => console.error('Errore nel download:', err));
  }

  toggleFullscreen(event: Event) {
    event.stopPropagation();
    const elem = document.querySelector('.custom-lightbox');

    if (!document.fullscreenElement) {
      elem?.requestFullscreen().catch(err => {
        console.error(`Errore nel tentativo di attivare il fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  }

  unlockAdventure(index: number) {
    this.unlockedAdventures[index] = true;
  }

  ngOnDestroy() {
    // this.subs.forEach(sub => sub.unsubscribe());
  }
}
